<!-- if mobile and has conversations, show the conversaton list -->
<!-- i.e. if desktop or has no conversations, show the welcome screen -->
<ng-container *ngIf="isMobile && (organizationHasConversations$ | async); else welcomeScreen">
  <inbox-pane></inbox-pane>
</ng-container>

<ng-template #welcomeScreen>
  <inbox-welcome></inbox-welcome>
</ng-template>
